/*eslint-disable */
import { Cloudinary } from 'cloudinary-core'
import 'cloudinary-video-player/dist/cld-video-player.light.min'

export default {
  name: 'cloudinary-player',

  ui: {
    video: '[js-cloudinary-player-video]',
    overlay: '[js-cloudinary-player-overlay]',
  },

  events: [
    {
      on: 'click',
      target: 'overlay',
      handle () {
        this.ui.overlay.classList.add('is-hidden')
        this.player.play()
      }
    }
  ],

  componentDidMount() {
    var cld = Cloudinary.new({
      cloud_name: process.env.CLOUDINARY_CLOUD_NAME,
    })
    
    this.player = cld.videoPlayer(this.ui.video.id, {
      controls: true,
      fluid: true,
    })
  },
}
/* eslint-enable */
